import {compose} from 'redux';
import {injectIntl} from 'react-intl';

import {createElement, PropTypes} from 'rlink-react';

import {INTL_MESSAGES} from '../messages/constants';

function getDays (year, month) {
  let nYear = Number(year);
  let nMonth = Number(month);
  let maxDaysDate = new Date(
    isNaN(nYear) ? 2000 : nYear,
    isNaN(nMonth) ? 0 : nMonth + 1,
    0
  );

  let maxDays = maxDaysDate.getDate();
  let days = [];

  for (let i = 1; i <= maxDays; i++) {
    days.push(<option key={i} value={i}>{i}</option>);
  }

  return days;
}

function DaySelector ({onChange, selectedDay, selectedMonth, selectedYear, intl}) {
  return (
    <select
      value={selectedDay}
      onChange={ev => onChange(Number(ev.target.value))}>
      <optgroup label={intl.formatMessage(INTL_MESSAGES.SELECT_DAY)}>
        {getDays(selectedYear, selectedMonth)}
      </optgroup>
    </select>
  );
}

DaySelector.propTypes = {
  onChange: PropTypes.func,
  selectedDay: PropTypes.number,
  selectedMonth: PropTypes.number,
  selectedYear: PropTypes.number,
  intl: PropTypes.object,
};

export default compose(
  injectIntl
)(DaySelector);



// WEBPACK FOOTER //
// ./lib/rlink-agegate/components/DaySelector.jsx